/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as vscode from 'vscode';
import { $ckc } from '../commands/selectTypeScriptVersion';
import { $Mhc } from '../configuration/languageIds';
import { $qic } from '../tsServer/versionProvider';
import { ITypeScriptServiceClient } from '../typescriptService';
import { $whc } from '../utils/dispose';


export class $dkc extends $whc {

	private readonly a: vscode.LanguageStatusItem;

	constructor(
		private readonly b: ITypeScriptServiceClient,
	) {
		super();

		this.a = this.g(vscode.languages.createLanguageStatusItem('typescript.version', $Mhc));

		this.a.name = vscode.l10n.t("TypeScript Version");
		this.a.detail = vscode.l10n.t("TypeScript Version");

		this.g(this.b.onTsServerStarted(({ version }) => this.e(version)));
	}

	private e(version: $qic) {
		this.a.text = version.displayName;
		this.a.command = {
			command: $ckc.id,
			title: vscode.l10n.t("Select Version"),
			tooltip: version.path
		};
	}
}
